export const SETTING_TABS = {
  ACCOUNT: {
    id: 'tab-account',
    title: 'Account',
    link: '/settings/account',
  },
  PREFERENCES: {
    id: 'tab-preferences',
    title: 'Preferences',
    link: '/settings/preferences',
  },
  SECURITY: {
    id: 'tab-security',
    title: 'Security',
    link: '/settings/security',
  },
  BILLING: {
    id: 'tab-billing',
    title: 'Billing',
    link: '/settings/billing',
  },
  ORGANIZATION: {
    id: 'tab-organization',
    title: 'Organization',
    link: '/settings/organization',
  },
  NOTIFICATIONS: {
    id: 'tab-notifications',
    title: 'Notifications',
    link: '/settings/notifications',
  },
  MEMORIES: {
    id: 'tab-memories',
    title: 'Memories',
    link: '/settings/memories',
  },
  LOCAL_RUNNERS: {
    id: 'tab-runners',
    title: 'Local Runners',
    link: '/settings/local-runners',
  },
  TOOLS: {
    id: 'tab-tools',
    title: 'Tools',
    link: '/settings/tools',
  },
} as const;
